import { useEffect } from "react";
import { Redirect } from "react-router-dom";
import {
  openSettingsAt,
  type SettingsView,
} from "../../domains/app/stores/settingsSheetStore";

// Module-level, so the effect below has a stable dependency: an inline object
// would be a new identity every render and re-open the sheet on each one.
const ROOT: SettingsView = { view: "root" };
const NOTIFICATIONS: SettingsView = { view: "notifications" };
const PARTNER_SHARING: SettingsView = { view: "partnerSharing" };
const PARTNERS: SettingsView = { view: "partners" };

export default function SettingsPage() {
  return <MobileSettingsSheetRedirect target={ROOT} />;
}

/**
 * `/settings/notifications` — the push and email switches, addressable.
 *
 * It exists because the emails link to it: a lifecycle email's footer offers
 * to adjust communication preferences, and before this the only address the
 * settings had was their root, so the reader landed one tap short of the
 * toggles they were promised.
 */
export function SettingsNotificationsPage(): React.JSX.Element {
  return <MobileSettingsSheetRedirect target={NOTIFICATIONS} />;
}

/**
 * `/settings/partner-sharing` — the switches of the partner objection. The
 * button of the information email opens it (docs/partner-objection.md,
 * REQ-17).
 */
export function SettingsPartnerSharingPage(): React.JSX.Element {
  return <MobileSettingsSheetRedirect target={PARTNER_SHARING} />;
}

/** `/settings/partners` — the partners list, linked from the same email. */
export function SettingsPartnersPage(): React.JSX.Element {
  return <MobileSettingsSheetRedirect target={PARTNERS} />;
}

/**
 * On mobile/native the settings UI is the app-wide `SettingsSheet`, not a
 * page. These URLs must stay routable (notification redirects, email links and
 * deep links target them), so they open the sheet over the profile page.
 */
function MobileSettingsSheetRedirect({
  target,
}: {
  target: SettingsView;
}): React.JSX.Element {
  useEffect(() => {
    openSettingsAt(target);
  }, [target]);
  return <Redirect to="/profile" />;
}
